import { validatePresence } from 'ember-changeset-validations/validators';
import MailchimpFundSyncModel from 'donor-elf-web/models/mailchimp-fund-sync';
import { isEmpty } from '@ember/utils';
import type { ValidationResult } from 'ember-changeset/types';

export default function validateMailchimpFundSync({
  allMailchimpFundSyncs,
}: {
  allMailchimpFundSyncs: MailchimpFundSyncModel[];
}) {
  return {
    mailchimpAccountId: validatePresence({
      presence: true,
      message: "Can't be blank",
    }),
    audienceId: validatePresence({ presence: true, message: "Can't be blank" }),
    fundId: (
      _key: string,
      newValue: string,
      _oldValue: string,
      _changes: any,
      content: MailchimpFundSyncModel,
    ): ValidationResult => {
      if (isEmpty(newValue)) {
        return 'Must be present';
      }
      let thisRecordId = content.id;
      if (
        allMailchimpFundSyncs.some(
          (x) => x.fundId === newValue && x.id !== thisRecordId,
        )
      ) {
        return "This fund is already synced with MailChimp. It can't be synced with multiple MailChimp accounts";
      }
      return true;
    },
  };
}
